export default {
  'clocks': [],
  'permanentRequiredFields': [
    'Salutation',
    'RequestInterest',
    'FirstName',
    'LastName',
    'Email',
    'RequestMessage'
  ],
  'requiredFields': {
    'default': [
      'Company',
      'PostalCode'
    ],
    'cooperation': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'consulting': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'offersGeneral': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'customer_serviceGeneral': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'other': [
      'PostalCode'
    ]
  }
}
